export default __webpack_public_path__ + "static/media/spinner.f0cec273.gif";